import React, { useState } from "react";
import { auth } from "../firebase-config";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { Navigate } from "react-router-dom";

export const Home = ({ user }) => {
  // Add state to manage the email and password
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Add state to manage the sign up and sign in forms
  const [isSignUpActive, setIsSignUpActive] = useState(false);
  const handleMethodChange = () => {
    setIsSignUpActive(!isSignUpActive); // Toggle the state
  };

  // Add functions to handle email and password changes
  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);

  // Add a function to handle sign up
  const handleSignUp = () => {
    // Check if the email and password are not empty
    if (!email || !password) return;

    createUserWithEmailAndPassword(auth, email, password)
      .then((userCred) => {
        const user = userCred.user;
        console.log(user);
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  // Add a function to handle sign in
  const handleSignIn = () => {
    // Check if the email and password are not empty
    if (!email || !password) return;

    signInWithEmailAndPassword(auth, email, password)
      .then((userCred) => {
        const user = userCred.user;
        console.log(user);
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  if (user) {
    return <Navigate to="/private"></Navigate>;
  }
  return (
    <section>
      <h2>Homepage</h2>
      <form>
        {isSignUpActive && <legend>Sign Up</legend>}
        {!isSignUpActive && <legend>Sign In</legend>}
        <fieldset>
          <ul>
            <li>
              <label htmlFor="email">Email</label>
              <input
                type="email"
                value={email}
                id="email"
                name="email"
                onChange={handleEmailChange}
                required
              />
            </li>
            <li>
              <label htmlFor="password">Password</label>
              <input
                type="password"
                value={password}
                id="password"
                name="password"
                minLength={6}
                onChange={handlePasswordChange}
                required
              />
            </li>
          </ul>
          {isSignUpActive && (
            <button type="button" onClick={handleSignUp}>
              Sign Up
            </button>
          )}
          {!isSignUpActive && (
            <button type="button" onClick={handleSignIn}>
              Sign In
            </button>
          )}
        </fieldset>

        {/* A link to switch between sign up and sign in */}
        {isSignUpActive && (
          <a onClick={handleMethodChange}>Already have an account? Sign In</a>
        )}
        {!isSignUpActive && (
          <a onClick={handleMethodChange}>Don't have an account? Sign Up</a>
        )}
      </form>
    </section>
  );
};
